import {Slash as icon } from "react-feather";

import { INotificationPlugin } from "../INotificationPlugin";

export default {
  title: "Unknown",
  icon,
  getDescription: () => "No description available",
} as INotificationPlugin<any>;
